import classnames from 'classnames/bind'
import { omit } from 'lodash-es'
import { useRouter } from 'next/router'

// Constants
import { LiveMallSearchType } from '@/types/live-mall-search/types'
import { UserType } from '@/types/user-story-carousel'
import { LIVE_MALL_SEARCH_CATEGORY_MAP } from '../../utils/constants'
import { CategorySharedProps } from '../../utils/types'

// Components
import UserStoryCarousel from '@/components/shared/livemallclub/UserStoryCarousel'
import { StateHandler } from '../_shared/StateHandler'
import LivesContent from '../Lives'
import ProductsContent from '../Products'

// Libs
import useLiveMallSearchQuery from '@/hooks/useLiveMallSearchQuery'

// Styles
import styles from './style.module.scss'
import { USER_ROLE } from '@/types/user-profile'

const cx = classnames.bind(styles)

const formatUsers = (rawData: LiveMallSearchType | undefined): UserType[] => {
  if (!rawData) return []

  const output: UserType[] = []

  if (rawData.merchantList) {
    output.push(
      ...rawData.merchantList.map((item) => ({
        merchantId: item.merchantId,
        memberId: item.memberId,
        coverImageUrl: item.headshotUrl,
        nickName: item.merchantName,
        isFollowed: item.isLike,
        isLive: item.hasLive,
        role: USER_ROLE.MERCHANT,
      })),
    )
  }

  if (rawData.memberList) {
    output.push(
      ...rawData.memberList.map((item) => ({
        merchantId: '',
        memberId: item.id,
        coverImageUrl: item.headshotUrl,
        nickName: item.nickName,
        isLive: item.hasLive,
        isFollowed: item.isLike,
        role: USER_ROLE.KOL,
      })),
    )
  }

  return output
}

const AllContent = () => {
  const keyword = useRouter().query.keyword
  const { data: queryResult, isFetching } = useLiveMallSearchQuery({
    keyword: String(keyword),
    type: LIVE_MALL_SEARCH_CATEGORY_MAP.ALL,
    enabled: !!keyword,
  })
  const sharedProps: CategorySharedProps = {
    style: {
      padding: '0 16px',
    },
    allQueryResult: queryResult,
  }
  const isEmpty = !!queryResult && !queryResult?.roomList && !queryResult?.productList && !queryResult?.merchantList && !queryResult?.memberList
  const users = formatUsers(queryResult)

  return (
    <StateHandler isFetching={isFetching} isEmpty={isEmpty} type='all'>
      <div className={cx('all-content')}>
        <UserStoryCarousel
          users={users}
          isFollowSuggest
          style={{
            padding: '0 20px',
          }}
        />
        <LivesContent {...sharedProps} />
        <ProductsContent {...omit(sharedProps, 'style')} />
      </div>
    </StateHandler>
  )
}

export default AllContent
